import { Attendees, GuestRooms, GuestRoomsAndEventSpace } from '../../organisms/SearchForm/SearchForm.types';

export type RoomsAndEventSpaceProps = {
  labels: RoomsAndEventSpaceLabels;
  showErrorMessage?: boolean;
  errorMessage?: string;
  showHelperText?: boolean;
  helperText?: string;
  variant: Variant;
  onChange: (data: RoomsAndEventSpace) => void;
  value?: RoomsAndEventSpace;
  isMobile?: boolean;
  fieldErrors?: RoomsAndEventSpaceFieldErrors;
};

export type RoomsAndEventSpace = {
  rooms: number;
  eventAttendees: number;
};

export type RoomsAndEventSpaceLabels = {
  guestRooms: GuestRooms;
  attendees: Attendees;
  guestRoomsAndEventSpace: GuestRoomsAndEventSpace;
  reset: string;
  resetAriaLabel: string;
};

export type RoomsAndEventSpaceFieldErrors = {
  rooms?: string;
  attendees?: string;
};

export enum Variant {
  ROOMS = 'ROOMS',
  EVENTSPACE = 'EVENTSPACE',
  ROOMSANDEVENTSPACE = 'ROOMSANDEVENTSPACE',
}
